import type {
  DeviceConfigurationAPI,
  RequestUpdateDeviceConfigurationAPI,
} from './definitions';

import {
  type DeviceConfiguration,
  MAXIMUM_OVERSPEEDING_THRESHOLD_IN_KMPH,
  type PageableContent,
  type PageableContentAPI,
  type UpdateDeviceConfiguration,
} from '@cobliteam/common-types';

const isOverSpeedingThresholdBelowMaximum = (
  speed_limit_threshold_in_kmh: number
) => {
  return speed_limit_threshold_in_kmh < MAXIMUM_OVERSPEEDING_THRESHOLD_IN_KMPH;
};

const isOverSpeedingEnable = (speed_limit_threshold_in_kmh: number | null) => {
  return speed_limit_threshold_in_kmh !== null
    ? isOverSpeedingThresholdBelowMaximum(speed_limit_threshold_in_kmh)
    : false;
};

export const toDeviceConfiguration = (
  deviceConfigurationAPI: DeviceConfigurationAPI
): DeviceConfiguration => ({
  deviceId: deviceConfigurationAPI.device_id,
  overSpeedingAlarmEnabled: isOverSpeedingEnable(
    deviceConfigurationAPI.speed_limit_threshold_in_kmh
  ),
});

export const toDeviceConfigurationPage = (
  page: PageableContentAPI<DeviceConfigurationAPI>
): PageableContent<DeviceConfiguration> => ({
  content: page.content.map(toDeviceConfiguration),
  last: page.last,
  totalPages: page.total_pages,
  totalElements: page.total_elements,
  numberOfElements: page.number_of_elements,
  number: page.number,
  size: page.size,
  first: page.first,
  empty: page.empty,
});

export const toRequestDeviceConfiguration = (
  devicesConfiguration: UpdateDeviceConfiguration
): RequestUpdateDeviceConfigurationAPI => ({
  device_id: devicesConfiguration.deviceId,
  speed_limit_threshold_in_kmh: devicesConfiguration.speedLimitThresholdInKmh,
  ignition_voltage_threshold_in_millis: null,
});
